<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ thirdPartyServiceProduct.name }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ thirdPartyServiceProduct.sku }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ thirdPartyService.service || 'unknown' }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    thirdPartyServiceProduct: {
      type: Object,
      required: true,
    },
  },
  computed: {
    thirdPartyService() {
      return (
        this.$store.state.entities.thirdPartyServices.byId[
          this.thirdPartyServiceProduct.thirdPartyServiceId
        ] || null
      );
    },
  },
};
</script>
